/**
 * @author Vivek Kumar <vivek.kumar@314ecorp.com>
 * @description PaymentAllocationUnallocatedAmountActions
 */
import { Dropdown } from 'antd';
import { MoreOne } from '@icon-park/react';
import { MenuItemType } from 'antd/es/menu/interface';

import Button from '.';
import { defaultDropdownButtonProps } from './ClaimTableActions';

export interface IProps {
	data: PatientPayment.IPaymentReconciliation;
	id: string;
	amount: number;
}

const PaymentAllocationUnallocatedAmountActions: React.FC<IProps> = ({ data, id, amount }) => {
	const schema: MenuItemType[] = [
		{
			key: 'refund',
			className: 'tw-dropdown-menu-item',
			label: <Button.RefundAllocation id={id} data={data} amount={amount} {...defaultDropdownButtonProps} />,
		},
	];

	return (
		<Dropdown menu={{ items: schema }} trigger={['hover']} overlayClassName='claim-actions-dropdown'>
			<Button icon={<MoreOne />} type='default' style={{ backgroundColor: 'white' }} />
		</Dropdown>
	);
};

export default PaymentAllocationUnallocatedAmountActions;
